// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__14ECx","title":"Info_title__5xMw0","selects":"Info_selects__41l6D","requiredAsterisk":"Info_requiredAsterisk__3akMk"};